import { createHashHistory } from 'history';

const history = createHashHistory({
  queryKey: false
});
export default history;
